import { render, staticRenderFns } from "./DeviceRename.vue?vue&type=template&id=69a7f064&lang=pug&"
import script from "./DeviceRename.vue?vue&type=script&lang=ts&"
export * from "./DeviceRename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeviceRename.vue"
export default component.exports